<template>
  <v-app>
    <v-main>
      <router-view/>
    </v-main>
  </v-app>
</template>

<script>

export default {
  name: 'App',
  watch: {
    title: {
      immediate: true,
      handler() {
        document.title = 'یزدگیشه';
      }
    }
  },
  data: () => ({
    //
  }),
}
</script>
<style>
#app{
  font-family: iranyekan;
  direction: rtl;
  //background-color: #00a5a7;
  background-image: url('assets/newback1.png');
  background-repeat: repeat;
  background-size: cover;
}
body{
  background-color: #00a5a7;
}
</style>